
import estateImg from "../assets/real.png";
import projectSaleImg from "../assets/projectSale.png" ;
import supplierImg from "../assets/supplierAgreement.png" ;
import stockImg from "../assets/stockAdjust.png";
import kaThaKhaImg from "../assets/kaThaKha.png" ;
import blogImg from "../assets/images.png";
import posImg from "../assets/pos1.jpg";
import rds from "../assets/rds.png";

// import posImg from "../../assets/pos1.jpg";
export const ProjectData = () => [
  {
    id: 1,
    title: "Request Document System",
    detail: "The Stock Adjust System is a backend-driven inventory adjustment platform designed to reconcile stock data between an ERP system and other external systems. It ensures consistent stock levels across platforms with secure role-based access and flexible data import capabilities.",
    img: rds,
    imageFit: "contain",
     source: "",
    seeMore: {
       roleTitle: "Full Stack Developer – Laravel, React",

    responsibilities: [
      "Developed an ERP system for document requests, approvals, and workflow automation.",
      "Implemented role-based access control (RBAC) to ensure secure and role-specific document handling.",
      "Integrated Web Push Notifications to notify users in real time about request submissions, approvals, and status changes.",
      "Enabled users to track request status and generate reports through responsive dashboards."
    ]
    },
  },
 {
    id: 2,
    title: "Supplier Agreement System",
    detail: "The Supplier Agreement System was developed to streamline and simplify the calculation and management of annual purchase invoices, focusing on supplier agreements and vendor-based tracking. Traditional systems often lack automation and role-based access, which this system addresses with a modern full-stack approach.",
    img: supplierImg,
    source: "",
    seeMore: {
       roleTitle: "Full Stack Developer – Laravel, React",

    responsibilities: [
      "Built a role-based system managing vendors, agreements, and purchase invoices.",
      "Implemented complex rebate and marketing percentage calculations (monthly, quarterly, yearly).",
      "Delivered real-time calculations with responsive React interfaces.",
      
    ],
    
    },
  },
  
  {
    id: 3,
    title: "Project Sale System",
    detail: "The Project Sale System was created to solve the challenges of managing and tracking projects across teams, roles, and regions in a secure and efficient way. Traditional project management tools often lack role-based security, map-based visualization, and smooth user experiences. This system combines these features into one modern web application. ",
    img: projectSaleImg,
     source: "",
     seeMore: {
       roleTitle: "Full Stack Developer – Laravel, React",

    responsibilities: [
  "Built a project and user management platform with role-based access control.",
  "Developed backend APIs and responsive frontend dashboards.",
  "Enabled project analysis, workflow control, and record tracking."
]

    },
  },
  {
    id: 4,
    title: "KaThaKhaForm System",
    detail: "The KaThaKhaForm System is a backend-driven application built solely with Laravel to track which users are required to submit taxes, monitor who has submitted, and track remaining obligations. It ensures compliance and simplifies tax tracking for administrators.",
    img: kaThaKhaImg,
    source: "",
    seeMore:{
      roleTitle: "Full Stack Developer – Laravel",
      responsibilities: [
  "Built a backend-driven system to track user tax submissions and monitor remaining obligations.",
  "Implemented role-based access to ensure only authorized administrators can view and modify sensitive tax data.",
  "Enabled administrators to monitor pending payments and manage users’ tax obligations efficiently.",
  "Designed reporting and tracking features to maintain compliance and generate historical records for auditing."
]

    }
   
  },
   {
    id: 5,
    title: "Real Estate Project",
    detail: "The Real Estate Project is a collaborative platform developed with Laravel, MySQL, jQuery, and Bootstrap. It simplifies property transactions by enabling administrators to manage listings and agents, while users can easily search, filter, and inquire about properties.",
    img: estateImg,
    source: "https://github.com/CreateTeam1234/RealEstate",
    seeMore: {
       roleTitle: "Full Stack Developer – Laravel, React",

    
    responsibilities: [
  "Developed backend features for property listings, agents, and categories.",
  "Implemented advanced filtering by city, township, and sale/rent status.",
  "Designed scalable architecture for future expansion."
]

    },
  },
   {
    id: 6,
    title: "Blog System",
    detail: "The Blog System is a web platform built with Laravel, MySQL, jQuery, and Bootstrap. It allows users to create, manage, and interact with blog posts, while administrators can oversee content moderation and gain insights through analytics.",
    img: blogImg,
    source: "https://github.com/HninSuWai12/BlogSystem",
     seeMore: {
       roleTitle: "Full Stack Developer – Laravel, React",

    responsibilities: [
  "Built a blog platform with authentication, post management, and admin dashboard.",
  "Implemented search, filtering, and comment moderation."
]

    },
  },
   {
    id: 7,
    title: "Point of Sale (POS) System",
    detail: "The POS System is an ordering platform developed with Laravel, MySQL, jQuery, and Bootstrap. It streamlines product management for administrators and offers users a smooth shopping and order-tracking experience.",
    img: posImg,
    source: "https://github.com/HninSuWai12/Pos-System",
     seeMore: {
       roleTitle: "Full Stack Developer – Laravel, React",

    
    responsibilities: [
  "Built a project and user management platform.",
  "Developed backend APIs and responsive frontend dashboards.",
  "Enabled project analysis, workflow control, and record tracking."
]

    },
  },
];

